<ng-container *transloco="let t; read:'permit.details.basic'">
    <div *ngIf="details$ | async as details" class="root">
        <div class="root__header">
            <div class="root__header__left">
                <div class="root__header__left__company-name" [innerHTML]="details.companyName"></div>
                <div class="root__header__left__workplace" [innerHTML]="fullWorkplaceName(details)"></div>
                <div class="root__header__left__company-name" [innerHTML]="details.workplaceAdditionalInfo"></div>
                <div *ngIf="details.permitAdditionalInformation" class="root__header__left__company-name">
                    <span class="root__header__left__company-name-label">{{ t("permitAdditionalInformation") }}</span> {{ details.permitAdditionalInformation }}
                </div>
                <div *ngIf="flammableAtexAdditionalInfo(details) as flammableAtexAdditionalInfo" class="root__header__left__company-name">
                    <span class="root__header__left__company-name-label">{{ t("flammableAtexAdditionalInfo") }}</span> {{ flammableAtexAdditionalInfo }}
                </div>
            </div>
            <div class="root__header__right">
                <div class="root__header__right__top">
                    <div class="root__header__right__top__flammable"
                         [class.root__header__right__top__flammable--not]="!details.isFlammableHotWork"
                         [attr.title]="t(details.isFlammableHotWork ? 'isFlammableHotWork' : 'notFlammableHotWork')"></div>
                    <div *ngIf="details.flammableAtexPermitId !== null"
                         class="root__header__right__top__explosion"
                         [attr.title]="t('flammableAtexPermitHeading')"></div>
                    <div *ngIf="details.flammableAtexHasMeasurements"
                         class="root__header__right__top__wind-warning"
                         [attr.title]="t('gasFreeDeclarationHeading')"></div>
                    <div *ngIf="details.isDemo" class="root__header__right__top__demo"></div>
                    <pmt-permit-public-status [status]="details.publicStatus"></pmt-permit-public-status>
                </div>
            </div>
        </div>
        <div class="root__emergency">
            <div *ngIf="details.emergencyNumber !== null" class="root__emergency__number" [innerHTML]="details.emergencyNumber"></div>
            <div *ngIf="details.emergencyLocation !== null" class="root__emergency__location" [innerHTML]="details.emergencyLocation"></div>
        </div>
    </div>
</ng-container>
